const PATH = 'components.application.dashboard.widgets.news';

const TRANSLATION_PATH = (route) => {
  return `${PATH}.${route}`;
};

export { PATH, TRANSLATION_PATH };
